$shm_hitalama_codex_general $shm_hitalama_codex_map
	map_id \
